<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Touren</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table style="width: 70vw;"
                  :headers="headers"
                  :items="tours.items.items"
                  :rows-per-page-items="[5,10,20,50,100]"
                  :loading="isLoading"
                  :total-items="totalItems"
                  :must-sort="true"
                  :pagination.sync="pagination"
                  class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr @click="rowClicked(props.item)">
        <td class="text-xs-left">{{ props.item.loadno }}</td>
        <td class="text-xs-left">{{ props.item.tourname }}</td>
        <td class="text-xs-left">{{ props.item.kfz }}</td>
        <td class="text-xs-left">{{ props.item.driverID }}</td>
        <td class="text-xs-left">{{ props.item.device }}</td>
        <td class="text-xs-left">{{ props.item.created_at | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showDetail" transition="dialog-bottom-transition" max-width="70vw">
      <TourDetail :key="tourDetailKey" style="height: 90vh;"></TourDetail>
    </v-dialog>
  </div>
</template>

<script>
import TourDetail from './TourDetail.vue';
export default {
  name: 'tours',
  components: {
    TourDetail
  },
  data() {
    return {
      totalItems: 0,
      tourDetailKey: 0,
      showDetail: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'loadno'
      },
      headers: [
        {
          text: 'Ladeschein',
          align: 'left',
          sortable: true,
          value: 'loadno'
        },
        {
          text: 'Tourname',
          align: 'left',
          sortable: true,
          value: 'tourname'
        },
        {
          text: 'KFZ',
          align: 'left',
          sortable: false,
          value: 'kfz'
        },
        {
          text: 'Fahrer',
          align: 'left',
          sortable: false,
          value: 'driverID'
        },
        {
          text: 'Gerät',
          align: 'left',
          sortable: false,
          value: 'device'
        },
        {
          text: 'Angelegt',
          align: 'left',
          sortable: false,
          value: 'created_at'
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    tours(newValue, oldValue) {
      this.totalItems = newValue.items.total;
    },
    completeTour(newValue, oldValue) {
      if (newValue != null) {
        this.showDetail = true;
      }
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    tours() {
      return this.$store.state.tours.all;
    },
    isLoading() {
      return this.$store.state.tours.loading;
    }
  },
  methods: {
    rowClicked(tour) {
      const loadno = tour.loadno;
      this.$store.dispatch('locations/getLoadnoSpecific', { loadno });
      this.$store.dispatch('tours/getCompleteTour', { loadno });
      this.tourDetailKey += 1;
      this.showDetail = true;
    },
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('tours/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    }
  }
};
</script>
